import {autoserializeAs, inheritSerialization} from 'cerialize';
import {Discount} from './discount';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class DiscountCode extends ModelBase {
  public static readonly type = 'DiscountCode';
  public readonly type = DiscountCode.type;

  @autoserializeAs('code')
  public code: string;

  @autoserializeAs(Discount, 'discount')
  public discount: Discount;
}
